(() => {
  'use strict';
  if (customElements.get('emolo-size-system')) return;
  const memory = new Map();
  const words = {
    es: {label:'Sistema de tallas', ring:'Equivalencias Émolo · Ø = diámetro interior', diameter:'Ø = diámetro de la pulsera', length:'Medidas del catálogo · in = pulgadas'},
    en: {label:'Size system', ring:'Émolo size equivalents · Ø = inner diameter', diameter:'Ø = bracelet diameter', length:'Catalogue measurements · in = inches'},
    fr: {label:'Système de tailles', ring:'Équivalences Émolo · Ø = diamètre intérieur', diameter:'Ø = diamètre du bracelet', length:'Mesures du catalogue · in = pouces'},
    pt: {label:'Sistema de tamanhos', ring:'Equivalências Émolo · Ø = diâmetro interior', diameter:'Ø = diâmetro da pulseira', length:'Medidas do catálogo · in = polegadas'}
  };
  class EmoloSizeSystem extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.field = this.closest('fieldset');
      const data = window.EmoloSizeData;
      const name = data?.products[this.dataset.productId]?.[this.dataset.optionPosition];
      this.profile = data?.profiles[name];
      if (!this.field || !this.profile) return;
      const nodes = this.field.querySelectorAll('[data-emolo-size-value]');
      // Shopify may keep a translated variant label (FR/UK/UE) even after the
      // catalog was corrected. Resolve it by its EU/US number before painting.
      this.resolveRow = raw => {
        if (this.profile.rows[raw]) return this.profile.rows[raw];
        const eu = raw.match(/(?:EU|UE|FR)\s*(\d+)/i)?.[1];
        const us = raw.match(/US\s*([0-9.]+)/i)?.[1];
        const values = [...raw.matchAll(/(?:ES|EU|UE|US|FR|UK)?\s*([0-9]+(?:\.[0-9]+)?)/gi)].map(m => m[1]);
        return Object.entries(this.profile.rows).find(([key,row]) =>
          (eu && row.EU === eu) || (us && row.US === us) ||
          values.some(value => Object.values(row).includes(value))
        )?.[1];
      };
      if (![...nodes].some(n => this.resolveRow(n.dataset.emoloSizeValue))) return;
      this.copy = words[document.documentElement.lang.slice(0,2)] || words.en;
      this.key = this.profile.kind === 'ring' ? 'ring' : 'length';
      let saved = memory.get(this.key);
      try { saved ||= sessionStorage.getItem('emolo-size-system:'+this.key); } catch (_) { /* Storage may be disabled. */ }
      const country = this.dataset.country;
      const initial = this.key === 'ring' ? (country === 'US' || country === 'CA' ? 'US' : country === 'ES' ? 'ES' : 'EU') : (country === 'US' ? 'in' : 'cm');
      this.system = this.profile.systems.includes(saved) ? saved : initial;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.replaceChildren();
      const group = document.createElement('div');
      group.className = 'emolo-size-systems'; group.role = 'group'; group.setAttribute('aria-label',this.copy.label);
      for (const system of this.profile.systems) {
        const button = document.createElement('button'); button.type='button'; button.dataset.system=system;
        button.textContent = system === 'mm' ? 'Ø mm' : system;
        button.addEventListener('click', () => {
          memory.set(this.key,system);
          try { sessionStorage.setItem('emolo-size-system:'+this.key,system); } catch (_) { /* Optional preference only. */ }
          document.querySelectorAll('emolo-size-system').forEach(el => {
            if (el.key === this.key && el.controller) { el.system=system; el.paint(); }
          });
        },{signal});
        group.append(button);
      }
      const help = document.createElement('p'); help.className='emolo-size-help'; help.textContent=this.copy[this.profile.kind];
      this.live = document.createElement('span'); this.live.className='sr-only'; this.live.setAttribute('aria-live','polite');
      this.append(group,help,this.live); this.hidden=false;
      this.field.addEventListener('change',()=>this.paint(),{signal});
      this.paint();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller=null; }
    paint() {
      this.querySelectorAll('[data-system]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.system===this.system)));
      this.field.querySelectorAll('[data-emolo-size-value]').forEach(node=>{
        const raw=node.dataset.emoloSizeValue;
        const row=this.resolveRow(raw);
        const value=row?.[this.system];
        const text = value === undefined ? raw : this.profile.kind === 'ring' ? (this.system === 'mm' ? `Ø ${value} mm` : `${this.system} ${value}`) : value;
        if(node.textContent!==text) node.textContent=text;
      });
      this.live.textContent=this.copy.label+': '+this.system;
    }
  }
  customElements.define('emolo-size-system',EmoloSizeSystem);
})();
